import { createRouter, createWebHistory } from 'vue-router'
import SessionsIndexView from './views/SessionsIndexView.vue'
import SessionDetailView from './views/SessionDetailView.vue'
import AstronomerProfileView from './views/AstronomerProfileView.vue'
import TargetDetailView from './views/TargetDetailView.vue'
import AboutView from './views/AboutView.vue'

const routes = [
  { path: '/', name: 'sessions', component: SessionsIndexView },
  { path: '/astronomers/:slug', name: 'astronomer', component: AstronomerProfileView },
  { path: '/astronomers/:slug/sessions/:id', name: 'session', component: SessionDetailView },
  { path: '/astronomers/:slug/targets/:id', name: 'target', component: TargetDetailView },
  { path: '/about', name: 'about', component: AboutView },
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
